import React, { useContext, useState, useEffect } from 'react'
import { Button, Tooltip } from '@mui/material'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import FullScreenPopup from '../../components/organisms/FullScreenPopup'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '../../common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Reorder from 'react-reorder'
import { arrayMoveImmutable } from 'array-move'
import SettingContext from '../../context/setting/settingContext'
import DynamicContext from '../../context/dynamic/dynamicContext'
import CustomDialog from '../../components/organisms/Dialog'
import DropdownValueManage from './dropdownManage'
import CustomCommonContext from '../../../custom/context/common/commonContext'
import './dynamic.css'

const FieldManage = (props) => {
    const settingcontext = useContext(SettingContext)
    const { getGlobalVariable, alldata_all_dropdown, allLocations } =
        useContext(CustomCommonContext)

    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const dynamiccontext = useContext(DynamicContext)
    const {
        propertyColumnReOrder,
        propertyColumnStatusAction,
        responseStatus: responseStatusDynamic,
    } = dynamiccontext

    const [changeStatus, setChangeStatus] = useState(false)

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        data: null,
    })

    const toggleFullScreenPopupDrop = (popup, status, data) => {
        if (popup) {
            setManage({ popup, status, data })
        } else {
            setManage({ popup, status: 'new', data: null })
        }
    }

    const data = props.data
    const toggleFullScreenPopup = props.function

    const [isLoading, setIsLoading] = useState(false)
    const [reload, setReload] = useState(false)
    const [tableBody, setTableBody] = useState([])
    const [tableBodyInActive, setTableBodyInActive] = useState([])

    const [viewPage, setViewPage] = useState(0)

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            active: 0,
            id: 0,
            table: 'data_all_dropdown',
        },
        onSubmit: (values) => {
            const dataValue = values
            if (
                dataValue.action === 'active' ||
                dataValue.action === 'deactive' ||
                dataValue.action === 'delete'
            ) {
                dataValue.active =
                    dataValue.action === 'delete'
                        ? 2
                        : dataValue.action === 'active'
                        ? 1
                        : 0
                delete dataValue.action
                searchTableAction(values, false, 'data_all_dropdown')
            }
        },
    })

    const onSelectMultiProducts = (id, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = id
        if (
            action === 'active' ||
            action === 'deactive' ||
            action === 'delete'
        ) {
            setChangeStatus(true)
        }
    }

    const formikFetch = useFormik({
        initialValues: {
            page: 1,
            limit: 1000,
            order: 'asc',
            orderby: 'dad.show_order',
            primaryTable: 'data_all_dropdown',
            filters: {
                active: {
                    value: '2',
                    type: 'notin',
                    field: 'dad.active',
                },
                description: {
                    value: '',
                    type: 'like',
                    field: 'dad.description',
                },
                variable: {
                    value: '',
                    type: 'in',
                    field: 'dad.variable',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            searchTableFetch(values, 'data_all_dropdown')
        },
    })

    useEffect(() => {
        if (props.name) {
            setTableBody([])
            setIsLoading(true)

            formikFetch.values.filters.active.value = '2'
            formikFetch.values.page = 1
            formikFetch.values.filters.variable.value = props.name
            formikFetch.values.filters.description.value = ''

            // formikDrop.values.variable = props.name
            // searchTableFetch(formikFetchDrop.values, 'data_all_dropdown')

            // setViewPage(data.id)
            // formikSelection.setFieldValue('viewPage', data.id)

            searchTableFetch(formikFetch.values, 'data_all_dropdown')
        }
    }, [props.name])

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'data_all_dropdown') {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records.filter(
                              (inner) => inner.active === 1
                          )
                        : []
                )
                console.log('search_fetch_data', search_fetch_data)
                setIsLoading(false)
            }
        }
    }, [search_fetch_data])

    useEffect(() => {
        if (responseStatusSetting) {
            if (responseStatusSetting.status === 'success') {
                if (responseStatusSetting.from === 'data_all_dropdown') {
                    setChangeStatus(false)
                    toggleFullScreenPopupDrop(false)
                    getGlobalVariable()
                    searchTableFetch(formikFetch.values, 'data_all_dropdown')
                }
            }
        }
    }, [responseStatusSetting])

    useEffect(() => {
        if (responseStatusDynamic) {
            if (responseStatusDynamic.status === 'success') {
                if (
                    responseStatusDynamic.from === 'propertyColumnAction' ||
                    responseStatusDynamic.from === 'propertyColumnStatusAction'
                ) {
                    setChangeStatus(false)
                    toggleFullScreenPopupDrop(false)
                    searchTableFetch(formikFetch.values, 'data_all_dropdown')
                }
            }
        }
    }, [responseStatusDynamic])

    const onClickEdit = (id, secondaryID, type) => {
        toggleFullScreenPopup(true, 'edit', id)
    }

    const onReorder = async (e, from, to) => {
        let changedArray = tableBody
        changedArray = await arrayMoveImmutable(changedArray, from, to)
        let idOrder = changedArray.map((cat, index) => {
            let orderValue = {
                id: cat.id,
                show_order: index,
            }
            return orderValue
        })
        propertyColumnReOrder({
            array: true,
            data: idOrder,
            table: 'data_all_dropdown',
        })
        setTableBody(changedArray)
        setReload(!reload)
    }

    return (
        <>
            {search_fetch_data?.records.length == 0 ? (
                <Button
                    id="add_new_field"
                    className="emptyDropdown"
                    onClick={() => toggleFullScreenPopupDrop(true, 'new', null)}
                >
                    <span className="material-icons">note_add</span>

                    <p>
                        {props.dropDownName
                            ? props.dropDownName
                            : 'Add a new dropdown value'}
                    </p>
                </Button>
            ) : (
                <Button
                    id="add_new_field"
                    variant="outlined"
                    className="addDropBtn"
                    onClick={() => toggleFullScreenPopupDrop(true, 'new', null)}
                >
                    <span className="material-icons">add_circle_outline</span>
                    {props.dropDownName
                        ? props.dropDownName
                        : 'Add a new dropdown value'}
                </Button>
            )}

            <>
                <Reorder
                    reorderId={'dropdownValues'}
                    reorderGroup={'dropdownValues'}
                    component="div"
                    // lock="horizontal"
                    className="reorderCnt dropdown"
                    draggedClassName="dragged"
                    touchHoldTime={250}
                    mouseHoldTime={100}
                    onReorder={onReorder}
                    autoScroll={true}
                    disabled={false}
                    disableContextMenus={true}
                >
                    {tableBody.map((data, index) => (
                        <div className="reorderItem" key={index}>
                            <span className="material-icons dragIcon">
                                drag_indicator
                            </span>
                            {props?.showId ? <h5>{data.id}</h5> : null}
                            &nbsp;-&nbsp;
                            <h5>{data.description}</h5>
                            <div className="roAct">
                                <Tooltip title="View Details">
                                    <Button
                                        id="dynamic_visiblity"
                                        onClick={() =>
                                            toggleFullScreenPopupDrop(
                                                true,
                                                'edit',
                                                data
                                            )
                                        }
                                    >
                                        <span className="material-icons">
                                            edit
                                        </span>
                                    </Button>
                                </Tooltip>

                                {data.is_default === 1 ? (
                                    <Tooltip title="Remove">
                                        <Button
                                            id="dynamic_remove"
                                            onClick={() =>
                                                onSelectMultiProducts(
                                                    data.id,
                                                    'deactive'
                                                )
                                            }
                                        >
                                            <span className="material-icons">
                                                close
                                            </span>
                                        </Button>
                                    </Tooltip>
                                ) : (
                                    <Tooltip title="Delete">
                                        <Button
                                            id="dynamic_delete"
                                            onClick={() =>
                                                onSelectMultiProducts(
                                                    data.id,
                                                    'delete'
                                                )
                                            }
                                        >
                                            <span className="material-icons">
                                                close
                                            </span>
                                        </Button>
                                    </Tooltip>
                                )}
                            </div>
                        </div>
                    ))}
                </Reorder>

                <DropdownValueManage
                    data={manage}
                    subLevel={props.subLevel}
                    name={props.name}
                    subField={props.subField}
                    avatar={props.avatar}
                    custom_language={props.custom_language}
                    diff_value={props.diff_value}
                    is_uppercase={props.is_uppercase}
                    function={toggleFullScreenPopupDrop}
                    show_order={
                        tableBody.length
                            ? tableBody[tableBody.length - 1].show_order + 1
                            : 1
                    }
                    dropDownName={props.dropDownName || ''}
                    dropDownNameEdit={props.dropDownNameEdit || ''}
                />

                <CustomDialog
                    title={'Change property status'}
                    open={changeStatus}
                    function={changeChangeStatus}
                    disableBackdropClick
                >
                    <h5>
                        {formikSelection.values.action === 'delete'
                            ? 'Are you sure you want to delete'
                            : 'Are you sure you want to change the status'}
                    </h5>
                    <div className="actionWrapper">
                        <Button
                            id="dynamic_cancel"
                            onClick={() => changeChangeStatus()}
                        >
                            Cancel
                        </Button>
                        <form
                            onSubmit={formikSelection.handleSubmit}
                            autoComplete="nofill"
                        >
                            <PrimaryButton
                                id="dynamic_field_submit"
                                type="submit"
                                label="Confirm"
                            />
                        </form>
                    </div>
                </CustomDialog>
            </>
        </>
    )
}

export default FieldManage
